/** Gép izomcsoport aliasok → kanonikus név */
export const MACHINE_MUSCLE_GROUP_ALIASES: Record<string, string> = {
  Biceps: 'Bicepsz',
  Has: 'Hasizom',
};

export function canonicalMachineMuscleGroup(type: string): string {
  return MACHINE_MUSCLE_GROUP_ALIASES[type] ?? type;
}

export function machineMuscleGroupMatches(
  machineType: string,
  selectedType: string
): boolean {
  if (!selectedType) return true;
  return canonicalMachineMuscleGroup(machineType) === canonicalMachineMuscleGroup(selectedType);
}
